<script setup>
import { ref, onMounted, watch } from 'vue'
import IMask from 'imask'

const props = defineProps({
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    required: true,
  },
  modelValue: [String, null],
  name: String,
})

const emit = defineEmits(['update:modelValue'])

const inputRef = ref(null)
let maskInstance = null

onMounted(() => {
  if (props.type === 'tel' && inputRef.value) {
    maskInstance = IMask(inputRef.value, {
      mask: '+000000000000',
    })
  }
})

watch(() => props.modelValue, (newVal) => {
  if (maskInstance && newVal !== maskInstance.value) {
    maskInstance.value = newVal || ''
  }
})

function onInput(e) {
  const value = e.target.value
  emit('update:modelValue', value)
}
</script>

<template>
  <div class="input-group">
    <input
        v-if="type === 'tel'"
        type="tel"
        :name="name"
        :id="name"
        :placeholder="placeholder"
        :value="modelValue"
        @input="onInput"
        ref="inputRef"
        required
    />

    <input
        v-else-if="type !== 'textarea' && type !== 'tel'"
        :type="type"
        :name="name"
        :id="name"
        :value="modelValue"
        :placeholder="placeholder"
        @input="onInput"
        ref="inputRef"
        required
    />

    <textarea
        v-else-if="type === 'textarea'"
        :name="name"
        :id="name"
        :placeholder="placeholder"
        :value="modelValue"
        @input="onInput"
        ref="inputRef"
        required
    ></textarea>
  </div>
</template>

<style scoped lang="scss">
.input-group {
  width: 100%;
  input, textarea {
    width: 100%;
    border: none;
    border-bottom: 1px solid rgba(135, 152, 253, 0.70);
    outline: none;
    background: none;
    padding: clamp(20px, 1.389vw, 100px) 0;
    color: #FFFFFF;
    font-family: "Rajdhani", sans-serif;
    font-size: clamp(18px, 1.25vw, 90px);
    font-weight: 500;
    line-height: 155.556%;
  }
  textarea {
    resize: vertical;
    min-height: clamp(155px, 10.764vw, 800px);
  }
}
</style>